import { useMemo, useRef } from "react";
import { ObjectFilterByKeys } from "utils/helpers";
import SelectFormulaInput from "../FormulaSelect/SelectFormulaInput";
import { useState } from "react";
import classNames from "classnames";
import { FormulaTree } from "utils/services";
import { useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from 'static/icons/close-small.svg';

import "./FormulaLabel.scss";

const FormulaLabel = ({ node, onUpdateItem, onDeleteItem }) => {
  const [active, setActive] = useState(false);

  const dropdownData = useSelector((state) => state.condition.dropdownData);

  const selectItemsHandler = onUpdateItem(node.id);

  const filtredKeys = {
    rest: [
      FormulaTree.NODE_TYPES.Variable,
      FormulaTree.NODE_TYPES.Value,
      FormulaTree.NODE_TYPES.Function,
      FormulaTree.NODE_TYPES.Brackets,
      FormulaTree.NODE_TYPES.Constants,
    ],
    [FormulaTree.NODE_TYPES.Operator]: [FormulaTree.NODE_TYPES.Operator],
  };

  const currentFilter =
    node.type === FormulaTree.NODE_TYPES.Operator
      ? filtredKeys[FormulaTree.NODE_TYPES.Operator]
      : filtredKeys["rest"];

  const labelColor = {
    [FormulaTree.NODE_TYPES.Function]: "#4E7D96",
    [FormulaTree.NODE_TYPES.Constants]: "#492D96",
    [FormulaTree.NODE_TYPES.Operator]: "#1A5D1A",
    [FormulaTree.NODE_TYPES.Value]: "#CA93EC",
    [FormulaTree.NODE_TYPES.Variable]: "#FA8700",
  };

  const dropdownDataToComponent = useMemo(() => {
    return ObjectFilterByKeys({
      object: dropdownData,
      keys: currentFilter,
    });
  }, [dropdownData, currentFilter]);

  const onDeleteItemHandler = () => {
    onDeleteItem(node.id)
    setActive(false)
  }

  const ref = useRef(null);

  return (
    <div ref={ref}>
      <span
        className={classNames({
          hidden: active,
          "variable-tag": node.type === FormulaTree.NODE_TYPES.Variable,
        })}
        style={{
          color: labelColor[node.type],
        }}
        onClick={() => setActive(true)}
      >
        {node.label}
      </span>

      {active && (
        <div className="label-input-wrapper">
          <SelectFormulaInput
            refLink={ref}
            setActive={setActive}
            initValue={node.name}
            onSelectItem={selectItemsHandler}
            initShowDropdown={true}
            dropdownData={dropdownDataToComponent}
          />
            <div className="label-input-icon">
              <CloseIcon onClick={onDeleteItemHandler}/>
            </div>
        </div>
      )}
    </div>
  );
};

export default FormulaLabel;
